// import React from 'react';
// import css from './product.module.css'
// import { useEffect, useRef, useState } from 'react';

// export default function PDFReader({pdfUrl, setIsTimerRunning}) {
//   const iframeRef = useRef(null);
//   function handleIntersect(entries, observer) {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         // Функція, яку ви хочете виконати при прокрутці до <iframe>
//         setIsTimerRunning(true);

//         // Зупинити спостереження, якщо вам більше не потрібно відслідковувати
//         observer.unobserve(entry.target);
//       }
//     });
//   }

//   useEffect(() => {
//     const iframe = iframeRef.current;

//     if (iframe) {
//       const observer = new IntersectionObserver(handleIntersect, { threshold: 0 });
//       observer.observe(iframe);

//       return () => {
//         observer.unobserve(iframe);
//       };
//     }
//   }, []);

//   return (
//     <div className={css.frameWrap}>
//       <iframe
//         src={pdfUrl}
//        className={css.frameStyle}
//         ref={iframeRef}
//         frameBorder="0"
//       />
//     </div>
//   );
// }
import { useEffect, useRef } from "react";
import css from "./product.module.css";

export default function PdfReader({ pdfUrl, onReachEnd }) {
  const iframeRef = useRef(null);

  const hasInteractedRef = useRef(false);
  const completedRef = useRef(false);
  const interactionStartedAtRef = useRef(null);

  useEffect(() => {
    hasInteractedRef.current = false;
    completedRef.current = false;
    interactionStartedAtRef.current = null;
  }, [pdfUrl]);

  const handleInteractionStart = () => {
    if (completedRef.current) return;

    if (!hasInteractedRef.current) {
      hasInteractedRef.current = true;
      interactionStartedAtRef.current = Date.now();
    }
  };

  const handleInteractionEnd = () => {
    if (!hasInteractedRef.current || completedRef.current) {
      return;
    }

    const interactionTime =
      Date.now() - (interactionStartedAtRef.current || Date.now());

    /*
     * Захист від випадкового наведення курсора.
     * Користувач повинен пробути в PDF хоча б 3 секунди.
     */
    if (interactionTime < 3000) {
      return;
    }

    completedRef.current = true;
    onReachEnd?.();
  };

  useEffect(() => {
    const checkFocus = () => {
      const iframe = iframeRef.current;

      if (!iframe) return;

      if (document.activeElement === iframe) {
        handleInteractionStart();
      }
    };

    const intervalId = window.setInterval(checkFocus, 300);

    const handleWindowFocus = () => {
      if (hasInteractedRef.current) {
        handleInteractionEnd();
      }
    };

    window.addEventListener("focus", handleWindowFocus);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, [onReachEnd]);

  if (!pdfUrl) {
    return (
      <div className={css.pdfMessage}>Коротка версія рукопису відсутня.</div>
    );
  }

  return (
    <div
      className={css.frameWrap}
      onMouseEnter={handleInteractionStart}
      onMouseLeave={handleInteractionEnd}
    >
      <iframe
        ref={iframeRef}
        src={pdfUrl}
        className={css.frameStyle}
        title="Коротка версія рукопису"
        frameBorder="0"
        tabIndex="0"
        onFocus={handleInteractionStart}
        onBlur={handleInteractionEnd}
        allowFullScreen
      />
    </div>
  );
}
